exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-641b7840]{text-indent:50px;line-height:30px\n}\n.foot[data-v-641b7840]{width:100%;text-align:center;margin-top:30px\n}", ""]);

// exports
